import { RslReport } from '../api/schema';

export const getReportChannels = (report: RslReport) => {
  const channelsByType = report.channels?.reduce(
    (acc, channel) => {
      acc[channel.channelType] = channel;
      return acc;
    },
    {} as Record<string, (typeof report.channels)[number]>
  );

  return {
    inStoreChannel: channelsByType?.in_store,
    onlineChannel: channelsByType?.online,
    combinedChannel: channelsByType?.combined,
  };
};
